import React, { useCallback, useEffect, useState } from "react";
import style from "./Users.module.scss";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import Pagination from "../../components/paginationCopy/Pagination";
import Search from "../../components/search";
import { loadHospitals } from "../../redux/admin/actions/admin.actions";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import { editHospitalType } from "../../data";
import { EditOutlined } from "@ant-design/icons";
import ModifyForm from "./ModifyForm";
import { SuccessModal } from "../../components/Modal/SuccessModal";
import MessageInstruction from "../../components/modalInstruction/MessageInstruction";
import { SortButton } from "../../components/utils/sortButton";
import Card2 from "../../components/paymentCard/Card2";

const Hospitals = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [modifyModal, setModifyModal] = useState(false);
  const [closeModal, setCloseModal] = useState(false);
  const [updateType, setUpdateType] = useState(false);
  const [dataMatch, setDataMatch] = useState();
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  const { hospitals } = useSelector((state) => state.adminReducer);

  useEffect(() => {
    setLoading(true);
    dispatch(loadHospitals());
    setLoading(false);
  }, [dispatch]);

  // Search handler
  useEffect(() => {
    setData(
      hospitals?.filter((id) => {
        return Object.values(id).some((name) =>
          String(name).toLowerCase().includes(search.toLowerCase())
        );
      })
    );
  }, [hospitals, search]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(data?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const editHandler = (type) => {
    window.localStorage.setItem("editType", type?.label);
    setUpdateType(false);
    setModifyModal(true);
  };

  let selectedType;

  if (window.localStorage.getItem("editType"))
    selectedType = window.localStorage.getItem("editType");

  const handleRow = (data) => {
    setUpdateType(true);

    let match = hospitals?.find((t) => t?.ref_id === data?.ref_id);
    if (match) {
      setDataMatch(match);
    }
  };

  const handleUpdate = () => {
    setModifyModal(false);
    setCloseModal(true);
  };

  const exitModal = () => {
    setCloseModal(false);
    dispatch(loadHospitals());
  };

  // sorting
  const [sortKey, setSortKey] = useState("name");
  const [sortOrder, setSortOrder] = useState("desc");

  function sortData({ tableData, sortKey, reverse }) {
    if (!sortKey) return tableData;

    const sortedData = data.sort((a, b) => {
      return a[sortKey] > b[sortKey] ? 1 : -1;
    });

    if (reverse) {
      return sortedData.reverse();
    }

    return sortedData;
  }

  const sortedData = useCallback(
    () => sortData({ tableData: data, sortKey, reverse: sortOrder === "desc" }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, sortKey, sortOrder]
  );

  const headers = [
    { key: "index", label: "S/N" },
    { key: "name", label: "Name" },
    { key: "blood_premium_name", label: "Class (Blood)" },
    { key: "oxygen_premium_name", label: "Class (Oxygen)" },
    { key: "contact_name", label: "Contact Name" },
    { key: "phone", label: "Phone" },
    { key: "state", label: "Address" },
  ];

  const changeSort = (key) => {
    setSortOrder(sortOrder === "ascn" ? "desc" : "ascn");
    setSortKey(key);
  };

  return (
    <>
      <div className="d-flex justify-content-between m-3">
        <div></div>
        <Search placeholder="Find a hospital" onChange={handleChange} />
      </div>
      <section style={{ maxWidth: "95%", margin: "auto" }}>
        {loading && <LinearLoader />}
        <Table borderless responsive className="mt-4">
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return (
                  <td key={row.key}>
                    {row.label}{" "}
                    <SortButton
                      columnKey={row.key}
                      onClick={() => changeSort(row.key)}
                      {...{ sortOrder, sortKey }}
                    />
                  </td>
                );
              })}
            </tr>
          </thead>
          {data?.length > 0 ? (
            <tbody>
              {sortedData()
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((hosp, index) => (
                  <tr
                    className={style.tableBodyRow}
                    key={index}
                    // onClick={() => handleRow(hosp)}
                  >
                    <td style={{ width: "7vw" }}>
                      {pageNumber * size + index + 1}
                    </td>
                    <td style={{ width: "20vw" }}>{hosp?.name}</td>
                    <td style={{ width: "12vw" }}>
                      {hosp?.blood_premium_name || "---"}
                    </td>
                    <td style={{ width: "12vw" }}>
                      {hosp?.oxygen_premium_name || "---"}
                    </td>
                    <td style={{ width: "15vw" }}>
                      {hosp?.contact_name || "---"}
                    </td>
                    <td style={{ width: "12vw" }}>{hosp?.fone || "---"}</td>
                    <td style={{ width: "25vw" }}>
                      {hosp?.address}, {hosp?.note}, {hosp?.city}, {hosp?.state}
                    </td>
                    <td className="d-flex gap-3 justify-content-center align-items-center">
                      <EditOutlined
                        className={style.action}
                        style={{ color: "gray", fontSize: "19px" }}
                        onClick={() => handleRow(hosp)}
                        // onClick={() => handleEdit(tick)}
                      />{" "}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              No record found
            </div>
          )}
        </Table>
        {data?.length > size && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>

      {/* update Modal */}
      <ConfirmationModal
        open={updateType}
        handleClose={() => setUpdateType(false)}
        closemodal={() => setUpdateType(false)}
        bgcolor=" rgba(255, 255, 255, 0.92)"
        width="60vw"
        instruction={
          // <div className="d-flex flex-column justify-content-center">
          //   <div className="d-flex justify-content-between mt-3 mb-3">
          //     <p className={styled.breadcumb} style={{ color: colors() }}>
          //       <EditOutlined style={{ fontSize: "35px" }} className="me-3" />
          //       <span>Which details would you like to update?</span>{" "}
          //     </p>
          //   </div>
          <div>
            <h3 className={style.header2}>What would you like to modify?</h3>
            <div className={style.cards}>
              {editHospitalType.map((type) => (
                <Card2
                  {...type}
                  key={type.id}
                  onClick={() => editHandler(type)}
                />
              ))}
            </div>
          </div>
          // </div>
        }
      />

      {/* edit MODAL */}
      <ConfirmationModal
        open={modifyModal}
        handleClose={() => setModifyModal(false)}
        closemodal={() => setModifyModal(false)}
        bgcolor="white"
        width="40vw"
        instruction={
          <div className="d-flex flex-column justify-content-center">
            <div className="d-flex justify-content-between mt-3 mb-3">
              <p className={style.breadcumb}>
                <EditOutlined
                  style={{ fontSize: "35px", color: "#950303" }}
                  className="me-3"
                />
                <span>
                  {selectedType === "ADDRESS"
                    ? "MODIFY HOSPITAL ADDRESS"
                    : selectedType === "CLASS"
                    ? "MODIFY CLASS"
                    : "MODIFY CONTACT DETAILS"}
                </span>{" "}
              </p>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <ModifyForm
                contact={dataMatch?.contact_name}
                phone={dataMatch?.fone}
                oxygen={dataMatch?.oxygen_premium_name}
                blood={dataMatch?.blood_premium_name}
                address={dataMatch?.address}
                city={dataMatch?.city}
                state={dataMatch?.state}
                ref_id={dataMatch?.ref_id}
                note={dataMatch?.note}
                onClickNo={() => setModifyModal(false)}
                onClickYes={() => handleUpdate()}
              />
            </div>
          </div>
        }
      />

      {/* Close MODAL */}
      <SuccessModal
        open={closeModal}
        onClose={() => setCloseModal(false)}
        bgcolor={"#b70303"}
        width="40vw"
        height="35vh"
        instruction={
          <MessageInstruction
            heading={`Hospital Details Updated Successfully!!`}
            // content={` It took this order ${closed?.time} Hours to be closed`}
            button="OKAY"
            onClickBtn={exitModal}
            color={"#fff"}
          />
        }
      />
    </>
  );
};

export default Hospitals;
